import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import Input from './componentsFinance/common/Input'
import Button from './componentsFinance/common/Button'
import Checkbox from './common/Checkbox'
import { domain } from '../utils/request'

export default function IncomeQuarterlyItemForm({ onCancel,
    loading,
    initialValues,
    incomeQuarterlyId,
    finance,
    onSubmit }) {
    const [file, setFile] = useState(null)

    async function onSuccess(data) {
        const newData = new FormData()
        if (file) {
            newData.append('incomeQuarterlyPdf', file, file.name)
        }

        newData.append('finance', finance.id)
        newData.append('incomeQuarterly', incomeQuarterlyId)
        newData.append('incomeQuarterlyComment', data.incomeQuarterlyComment)
        newData.append('tax', data.tax)
        newData.append('inps', data.inps)

        onSubmit(newData)
    }


    return (
        <Formik onSubmit={onSuccess} initialValues={{
            incomeQuarterlyComment: '',
            tax: false,
            inps: false,
            ...initialValues,
            incomeQuarterlyPdf: null,
        }}>

            {({
                setFieldValue,
            }) => (
                <Form>
                    <div className="columns">
                        <div className="column">
                            <Input
                                name="incomeQuarterlyComment"
                                label="Комментарий"
                                disabled={loading}
                                placeholder="Комментарий" />
                        </div>

                    </div>
                    <Checkbox
                        name="tax"
                        label="Солиқлар тўланиши"
                        disabled={loading}
                        placeholder="Комментарий" />

                    <Checkbox
                        name="inps"
                        label="ИНПС реестр"
                        disabled={loading}
                        placeholder="Комментарий" />


                    <div className="columns">
                        <div className="column">
                            <p className="level-left">
                            Фойда солиғи
                            </p>

                            <input
                                name="incomeQuarterlyPdf"
                                onChange={(e) => {
                                    setFieldValue('incomeQuarterlyPdf', e.target.value)
                                    setFile(e.target.files[0])
                                }}
                                type="file"
                                disabled={loading} />
                            {initialValues ? (domain + initialValues.incomeQuarterlyPdf).split('/').pop() : 'Файл юкланмаган'}
                        </div>

                    </div>

                    <Button
                        loading={loading}
                        text="Сохранить"
                        type="submit"
                        icon="ion-md-checkmark"
                        className="is-success" /> &nbsp;

                    <Button
                        onClick={onCancel}
                        icon="ion-md-close"
                        text="Отмена"
                        className="is-danger" />
                </Form>
            )}
        </Formik>
    )
}
